import logo from './logo.svg';
import './App.css';
import FormRoute from './Routercomponent/FormRoute';

function App() {
  return (
    <FormRoute/>
  );
}

export default App;
